import { showError, showSuccess } from '@calendly/alert'
import { I18n } from '@calendly/i18n'
import { useEffect, useRef } from 'react'
import { useDispatch } from 'react-redux'

import { useUpdateFollowUpEmailPreferencesMutation } from 'features/crm'

const FOLLOW_UP_EMAIL_PARAM = 'follow_up_email'
const FOLLOW_UP_EMAIL_UNSUBSCRIBE_VALUE = 'unsubscribe'

const shouldUnsubscribeFromFollowUpEmail = () => (
  new URLSearchParams(window.location.search).get(FOLLOW_UP_EMAIL_PARAM)
    === FOLLOW_UP_EMAIL_UNSUBSCRIBE_VALUE
)

const clearFollowUpEmailParam = () => {
  const searchParams = new URLSearchParams(window.location.search)
  searchParams.delete(FOLLOW_UP_EMAIL_PARAM)

  const search = searchParams.toString()
  window.history.replaceState(
    window.history.state,
    '',
    `${window.location.pathname}${search ? `?${search}` : ''}${window.location.hash}`
  )
}

/** Handles `?follow_up_email=unsubscribe` from the recommended follow-ups email footer. */
export const FollowUpEmailUnsubscribeHandler = () => {
  const dispatch = useDispatch()
  const [updateFollowUpEmailPreferences] = useUpdateFollowUpEmailPreferencesMutation()
  const hasHandledUnsubscribe = useRef(false)

  useEffect(() => {
    if (
      !shouldUnsubscribeFromFollowUpEmail()
      || hasHandledUnsubscribe.current
    ) {
      return
    }

    hasHandledUnsubscribe.current = true
    clearFollowUpEmailParam()

    updateFollowUpEmailPreferences({ enabled: false })
      .unwrap()
      .then(() => {
        dispatch(showSuccess(
          I18n.t('publisher.account_settings.communication_settings.follow_up_email_unsubscribe_success')
        ))
      })
      .catch((error) => {
        console.error('Failed to unsubscribe from follow-up email:', error)
        dispatch(showError(
          I18n.t('publisher.account_settings.communication_settings.follow_up_email_unsubscribe_error')
        ))
      })
  }, [dispatch, updateFollowUpEmailPreferences])

  return null
}
